const baseUrl= "https://wenchuang.wcyj2020.com";//测试
export const basePath = baseUrl+"/api/"; //接口
// const baseUrl= "http:///192.168.1.70:9090";//本地
// export const basePath = baseUrl; //本地接口
export const baseImage = baseUrl; //图片


// WEBPACK FOOTER //
// ./src/util/berurl.js